// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"927ad279","191":"c9844886","337":"ac06aede","692":"462e01a5","990":"d96c8aef"}[chunkId] + ".chunk.js";
};